import { useState, useEffect, useRef } from "react";
import { API } from "@/App";

const PING_INTERVAL = 30000; // 30s

export function ConnectionIndicator({ isCollapsed }) {
  const [status, setStatus] = useState("connected"); // connected | degraded | disconnected
  const failCountRef = useRef(0);

  useEffect(() => {
    let mounted = true;

    const ping = async () => {
      try {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 5000);
        const res = await fetch(`${API}/ping`, { signal: controller.signal });
        clearTimeout(timeout);
        if (res.ok) {
          failCountRef.current = 0;
          if (mounted) setStatus("connected");
        } else {
          failCountRef.current++;
          if (mounted) setStatus(failCountRef.current >= 2 ? "disconnected" : "degraded");
        }
      } catch {
        failCountRef.current++;
        if (mounted) setStatus(failCountRef.current >= 2 ? "disconnected" : "degraded");
      }
    };

    ping();
    const interval = setInterval(ping, PING_INTERVAL);
    return () => { mounted = false; clearInterval(interval); };
  }, []);

  const config = {
    connected:    { color: "bg-emerald-400", ring: "ring-emerald-400/30", label: "Connecté" },
    degraded:     { color: "bg-amber-400",   ring: "ring-amber-400/30",   label: "Connexion instable" },
    disconnected: { color: "bg-red-400",     ring: "ring-red-400/30",     label: "Déconnecté" },
  };
  const c = config[status];

  return (
    <div
      className={`flex items-center ${isCollapsed ? "justify-center" : "gap-2 px-3"} py-1.5 group relative`}
      data-testid="connection-indicator"
    >
      <span className={`relative flex h-2.5 w-2.5 flex-shrink-0`}>
        {status !== "connected" && (
          <span className={`absolute inline-flex h-full w-full animate-ping rounded-full ${c.color} opacity-60`} />
        )}
        <span className={`relative inline-flex h-2.5 w-2.5 rounded-full ${c.color} ring-2 ${c.ring}`} />
      </span>
      {!isCollapsed && (
        <span className={`text-xs font-medium ${status === "connected" ? "text-emerald-600" : status === "degraded" ? "text-amber-600" : "text-red-600"}`}>
          {c.label}
        </span>
      )}
      {isCollapsed && (
        <div className="absolute left-full ml-2 px-2 py-1 bg-zinc-800 text-white text-xs rounded opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all whitespace-nowrap z-50">
          {c.label}
        </div>
      )}
    </div>
  );
}
